/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module swipeView
 */
  import $ from 'jquery';
  import $script from 'scriptjs';
  import registerJQueryPlugin from '../lib/register-jquery-plugin';
  import mergeOptions from '../lib/merge-options';
  import { get } from '../lib/props';
  // import { init } from 'browser-sync';

  const HAMMERJS_FALLBACK = 'https://ajax.googleapis.com/ajax/libs/hammerjs/2.0.8/hammer.min.js';
  export const PLUGIN_NAME = 'swipeView';

/**
 * Makes a request for HammerJS.
 * @private
 * @return {Promise} Denotes when the request has been successfully executed
 */
  const loadHammerJSFunc = () =>
  new Promise((resolve) => {
    $script(get('scripts.hammerJS', HAMMERJS_FALLBACK), () => {
      resolve(window.Hammer);
    });
  });
  export const DEFAULTS = {
    loadHammerJS: loadHammerJSFunc,
  };

  /**
  * Applies any sort of event handlers for the checkboxes or radios.
  * @param  {jQuery} $el - checkbox / radio
  * @param  {Object} [options={}] - Any options provided upon initialization
  */
  const setEventListeners = ($el, hammertime) => {
    const activeClass = 'active';
    hammertime.on('swiperight', () => {
      const isActive = $el.hasClass(activeClass);
      if (isActive) {
        $el.removeClass(activeClass);
      }
    });
    hammertime.on('swipeleft', () => {
      const isActive = $el.hasClass(activeClass);
      if (!isActive) {
        $el.addClass(activeClass);
      }
    });
  };

 /**
  * Applies any sort of event handlers for the checkboxes or radios.
  * @param  {jQuery} $el - checkbox / radio
  * @param  {Object} [options={}] - Any options provided upon initialization
  */
  const initHammer = ($el, opts) => {
    opts.loadHammerJS().then((Hammer) => {
      const hammertime = new Hammer($el[0]);
      hammertime.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
      setEventListeners($el, hammertime);
    });
  };

 /**
  * Initializes swipeView.
  * @param {HTMLElement} el - button /element that triggers swipeView
  * @param {Object} options - Options used for wiring up the swipeView
  * @param {Object} deregister - Performs a deregisteration on the plugin
  * @see DEFAULTS
  */
  export default function swipeView(el, options = {}) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    initHammer($el, opts);
  }
  registerJQueryPlugin(PLUGIN_NAME, swipeView);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/swipe-view.js